import { ref } from '@vue/composition-api'
import {
  mdiCashCheck,
  mdiCashClock,
  mdiCashPlus,
  mdiCashRemove,
} from '@mdi/js'

export default function usePaymentsStatusesList() {
  const paymentsStatusesList = ref([
    {
      id: 1,
      text: 'No Pagado',
      color: '#EF5350',
      icon: mdiCashRemove,
    }, {
      id: 2,
      text: 'Parcial',
      color: '#BA68C8',
      icon: mdiCashClock,
    }, {
      id: 3,
      text: 'Pagado',
      color: '#66BB6A',
      icon: mdiCashCheck,
    }, {
      id: 4,
      text: 'Sobre Pagado',
      color: '#FFA726',
      icon: mdiCashPlus,
    },
  ])

  const GetById = id => paymentsStatusesList.value.find(item => item.id === id)

  return {
    paymentsStatusesList,
    GetById,
  }
}
